import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { CourseProgressSummary, UnitProgress } from '../data/student-report';
import { Course } from '../data/course';
import { FormatUtilities } from '../utilities/format-utilities';

@Component({
  selector: 'app-student-progress-report-pathways',
  templateUrl: './student-progress-report-pathways.component.html',
  styleUrls: ['./student-progress-report-pathways.component.scss']
})

export class StudentProgressReportPathwaysComponent extends BaseComponent implements OnInit {
  @Input() courseSummaries: CourseProgressSummary[];
  @Input() studentId: number;

  displayTimeWithoutSeconds = FormatUtilities.displayTimeWithoutSeconds;
  longDateFormat = FormatUtilities.longDateFormat;

  currentStrand: string = "P-OralLanguage";
  currentStrandSummary: CourseProgressSummary;

  onTabClicked(strandCourseCode: string) : void {
    this.currentStrand = strandCourseCode;
    this.currentStrandSummary = this.courseSummaries.find(x => x.CourseCode == strandCourseCode);
  }

  getPathwaysTimeSpent() : number {
    var pathwaysCourses = this.courseSummaries.filter(x => x.CourseCode.startsWith("P-") || x.CourseCode == "Pathways");
    return pathwaysCourses.map(x => x.TimeSpent).reduce( (x, y) => { return x+y; });
  }

  getPathwaysLastActivity() : Date {
    var pathwaysCourses = this.courseSummaries.filter(x => x.CourseCode.startsWith("P-") || x.CourseCode == "Pathways");
    return new Date(Math.max(...pathwaysCourses.map(course => course.LastStartedActivity?.getTime())));
  }

  ngOnInit(): void {
    this.onTabClicked("P-OralLanguage");
  }
}
